import { Heading } from "@components/typography"
import { Container, FlexBox } from "@components/wrapper"
import { ProgramInfo } from "@interfaces/program"
import ProgramServices from "@lib/api/services/program.services"
import clsx from "clsx"
import { FC, useEffect, useState } from "react"
import { AiOutlineCheck } from "react-icons/ai"
import { ProfessionalScope } from "./ProfessionalScope"

export const OurProgram: FC = () => {
  const [activeTab, setActiveTab] = useState(0)

  const [isLoading, setIsLoading] = useState(false)
  const [programList, setProgramList] = useState<ProgramInfo[]>([])

  const program = new ProgramServices()

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await program.getPrograms()
        if (res.isSuccess) {
          const result = res.getValue()
          setProgramList(result)
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      } catch (e) {
        setIsLoading(false)
      }
    }

    getData()
  }, [])
  
  if (!programList.length) return null

  return (
    <section className="sm:pt-15 pt-10 relative">
      <div id="#our-program" className="absolute -top-15" />
      <Container>
        <Heading headingLevel="title" className="sm:mb-4 mb-2 text-center">
          Program Terbaik Kami
        </Heading>

        {Boolean(programList.length) && (
          <div className="sm:mb-15 mb-10">
            {/* tabs */}
            <FlexBox className="sm-only:overflow-scroll">
              {programList.map((value, index) => (
                <div
                  className={clsx(
                    index === activeTab ? "text-blue" : "text-black-67 border-white-f9",
                    "w-full text-center font-semibold sm:text-lg border-b-4 cursor-pointer sm:p-4 ease-in-out",
                    "text-xs p-3"
                  )}
                  key={index}
                  onClick={() => setActiveTab(index)}
                >
                  {value.programName}
                </div>
              ))}
            </FlexBox>

            {/* tabs workshop */}
            <div className="pt-5 md:pt-8">
              <div className="w-full sm:w-3/5">
                <h3 className={clsx("font-semibold sm:text-title sm:mb-3", "text-lg mb-2")}>
                  {programList[activeTab].programTitle}
                </h3>
                <p
                  className={clsx(
                    "text-black-67 sm:mb-8",
                    "mb-5 sm-only:text-xs sm-only:leading-[18px]"
                  )}
                >
                  {programList[activeTab].programDescription}
                </p>
                <div className="flex sm:gap-4 gap-3 flex-wrap">
                  {programList[activeTab]?.tags.map((value, index) => (
                    <div
                      className={clsx(
                        "flex gap-4 bg-white-f9 rounded-full sm:py-1 sm:px-2",
                        "sm-only:text-xs py-1.5 px-3"
                      )}
                      key={index}
                    >
                      <div className="my-auto">
                        <AiOutlineCheck color="blue" />
                      </div>
                      <p className="text-black-67">{value.tagName}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <ProfessionalScope data={programList[activeTab].services ?? []} />
          </div>
        )}
      </Container>
    </section>
  )
}
